/**
 * Every date and time shown in the Hub and the partner portals is London time.
 * The desk runs on UK hours, so a case that landed at 09:12 must read 09:12 whether
 * the person looking at it is in Bangkok, Dubai or Leeds — never the device's clock.
 */
export const UK_TZ = "Europe/London";

const mk = (opts) => new Intl.DateTimeFormat("en-GB", { timeZone: UK_TZ, ...opts });

const F_TIME = mk({ hour: "2-digit", minute: "2-digit" });
const F_DAY = mk({ day: "2-digit", month: "short" });
const F_DAY_YEAR = mk({ day: "2-digit", month: "short", year: "numeric" });
const F_DAY_TIME = mk({ day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
const F_WEEKDAY = mk({ weekday: "short", day: "2-digit", month: "short" });
const F_WD_TIME = mk({ weekday: "short", hour: "2-digit", minute: "2-digit" });
const F_NUMERIC = mk({ day: "2-digit", month: "2-digit", year: "numeric" });
const F_KEY = mk({ year: "numeric", month: "2-digit", day: "2-digit" });

const asDate = (v) => {
  if (!v) return null;
  const d = v instanceof Date ? v : new Date(v);
  return isNaN(d.getTime()) ? null : d;
};

const via = (f) => (value, fallback = "") => {
  const d = asDate(value);
  return d ? f.format(d).replace("Sept", "Sep") : fallback;
};

export const ukTime = via(F_TIME);
export const ukDay = via(F_DAY);
export const ukDayYear = via(F_DAY_YEAR);
export const ukDayTime = via(F_DAY_TIME);
export const ukWeekday = via(F_WEEKDAY);
export const ukWeekdayTime = via(F_WD_TIME);
export const ukNumeric = via(F_NUMERIC);
export const ukDayKey = via(F_KEY);

export const isUkToday = (value) => {
  const key = ukDayKey(value);
  return !!key && key === ukDayKey(new Date());
};

/** "just now" · "14m ago" · today's UK time · otherwise the UK date. */
/** "Tue 28 Oct · 14:32" — the stamp on every message in a thread. */
export const ukStamp = (value) => {
  const d = asDate(value);
  return d ? `${F_WEEKDAY.format(d)} · ${F_TIME.format(d)}` : "";
};

export const ukWhen = (value) => {
  const d = asDate(value);
  if (!d) return "";
  const mins = (Date.now() - d.getTime()) / 60000;
  if (mins < 1) return "just now";
  if (mins < 60) return `${Math.floor(mins)}m ago`;
  return isUkToday(d) ? ukTime(d) : ukDay(d);
};
